import http from 'plugins/axios';

export default {
  getLimitSwitchList(data) {
    return http.get({
      url: '/la/admin/otc/limit/switch',
      data
    });
  },
  deleteOtcLimit({ userId }) {
    return http.post({
      url: '/la/admin/delete/otc/limit?userId=' + userId,
    });
  }
};
